"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var selector_js_1 = require("../../../../list-selector/app/js/logic/selector.js");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var cmpts;
        (function (cmpts) {
            var selector;
            (function (selector) {
                var table;
                (function (table) {
                    var TableListItem = /** @class */ (function (_super) {
                        __extends(TableListItem, _super);
                        function TableListItem(rowHeader, colHeader) {
                            var _this = _super.call(this, [rowHeader, colHeader].join('-'), undefined) || this;
                            _this.rowHeader = rowHeader;
                            _this.colHeader = colHeader;
                            return _this;
                        }
                        TableListItem.prototype.getCell = function () {
                            return {
                                rowHeader: this.rowHeader,
                                colHeader: this.colHeader
                            };
                        };
                        return TableListItem;
                    }(selector_js_1["default"].ListItem));
                    table.TableListItem = TableListItem;
                    var TableSelector = /** @class */ (function (_super) {
                        __extends(TableSelector, _super);
                        /**
                         * Initialize the table.
                         *
                         * @param rowHeaders {Array<string>}
                         * @param colHeaders {Array<string>}
                         */
                        function TableSelector(rowHeaders, colHeaders) {
                            var _this = this;
                            var items = [];
                            if (rowHeaders && colHeaders) {
                                for (var i = 0; i < rowHeaders.length; i++) {
                                    for (var j = 0; j < colHeaders.length; j++) {
                                        items.push(new TableListItem(rowHeaders[i], colHeaders[j]));
                                    }
                                }
                            }
                            _this = _super.call(this, [], items, undefined, undefined) || this;
                            _this.rowHeaders = rowHeaders;
                            _this.colHeaders = colHeaders;
                            return _this;
                        }
                        // Todo: finish this function.
                        /**
                         * Add or remove items from row headers and col headers base
                         * on chosen/notchosen items.
                         */
                        TableSelector.prototype.handleHeaders = function () {
                            // Table list items object
                        };
                        /**
                         * Combine selected row and col then add items into chosen list.
                         *
                         * @param row {Array<string>} Selected row headers.
                         * @param col {Array<string>} Selected col headers.
                         */
                        TableSelector.prototype.addCellsToChosen = function (row, col) {
                            var list = [];
                            if (row && row.length || col && col.length) {
                                // no row selected -> select whole col.
                                var r = row;
                                if (!row || !row.length) {
                                    r = this.rowHeaders.slice(0);
                                }
                                var c = col;
                                if (!col || !col.length) {
                                    c = this.colHeaders.slice(0);
                                }
                                for (var i = 0; i < r.length; i++) {
                                    for (var j = 0; j < c.length; j++) {
                                        list.push(new TableListItem(r[i], c[j]));
                                    }
                                }
                            }
                            // Cannot call the super function because we are not handling
                            // the notchosen list here.
                            // Todo: Test this function after changing to call super.
                            if (list.length) {
                                _super.prototype.addToChosen.call(this, list);
                                // for (let k = 0; k < list.length; k++) {
                                //     if (Selector.itemIndexFromArray(this.chosen, list[k]) < 0) {
                                //         this.chosen.push(list[k]);
                                //     }
                                // }
                                //
                                // Selector.filterListFromSource(this.notChosen, list);
                                // this.checkSave();
                            }
                            // Handle row and col list.
                            this.handleHeaders();
                        };
                        /**
                         * Remove an list of items from chosen.
                         *
                         * @param list {Array<TableListItem>} List of items to remove.
                         */
                        TableSelector.prototype.removeFromChosen = function (list) {
                            _super.prototype.removeFromChosen.call(this, list);
                            // Handle row and col list.
                            this.handleHeaders();
                        };
                        /**
                         * Move all items from unchosen to chosen.
                         */
                        TableSelector.prototype.addAll = function (searchKey) {
                            _super.prototype.addAll.call(this, searchKey);
                            // Handle row and col list.
                            this.handleHeaders();
                        };
                        /**
                         * Move all items from chosen to unchosen.
                         */
                        TableSelector.prototype.removeAll = function () {
                            _super.prototype.removeAll.call(this);
                            // Handle row and col list.
                            this.handleHeaders();
                        };
                        return TableSelector;
                    }(selector_js_1["default"].Selector));
                    table.TableSelector = TableSelector;
                })(table = selector.table || (selector.table = {}));
            })(selector = cmpts.selector || (cmpts.selector = {}));
        })(cmpts = r6.cmpts || (r6.cmpts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.cmpts.selector.table;
//# sourceMappingURL=table-selector.js.map


// WEBPACK FOOTER //
// ./app/components/table-selector/app/js/logic/table-selector.js